import { ProxyTypeName } from '@fd/common/biz/proxyType';
import useActiveSbSubscription from './queries/useSbSubscription';
import useAccount from './queries/useAccount';
import { bytesToGb } from '@fd/common/biz/formatBytesToGb';

export const useTariffByProxyType = (proxyType: ProxyTypeName) => {
  const { data: activeSubscription } = useActiveSbSubscription();
  const account = useAccount();

  if (proxyType === 'residential') {
    return {
      trafficGb: bytesToGb(activeSubscription?.residential_bytes || 0),
      tagId: account?.residential_tag_id,
      meter_subscription_id: account?.residential_sub_id,
    };
  }
  if (proxyType === 'mobile') {
    return {
      trafficGb: bytesToGb(activeSubscription?.mobile_bytes || 0),
      tagId: account?.mobile_tag_id,
      meter_subscription_id: account?.mobile_sub_id,
    };
  }
  if (proxyType === 'datacenter') {
    return {
      trafficGb: bytesToGb(activeSubscription?.datacenter_bytes || 0),
      tagId: account?.datacenter_tag_id,
      meter_subscription_id: account?.datacenter_sub_id,
    };
  }
  throw new Error(`Unknown proxyType: ${proxyType}`);
};
